import { createStore, compose, applyMiddleware } from "redux";
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import createRootReducer from './reducers'
import { googleAnalytics } from '../shared/googleAnalytics';
export const history = createBrowserHistory()

let middleware = [thunk, routerMiddleware(history), logger];

if(window.appConfig.ga) {
  middleware.push(googleAnalytics);
}

export default function configureStore() {
  const store = createStore(
    createRootReducer(history),
    compose(
      applyMiddleware(
        ... middleware
      ),
    ),
  )

  return store
}
